import { z } from 'zod';

export const answerEnglishIqV1RequestSchema = z.object({
  choice: z.string().min(1),
  itemId: z.string().min(1),
  token: z.string().min(1),
});

export type IAnswerEnglishIqV1Request = z.infer<typeof answerEnglishIqV1RequestSchema>;
